import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/NutricionistaBrasileiraMelbourne";
import { pageHead, faqJsonLd, breadcrumbJsonLd } from "@/lib/seo";
import { SITE_URL } from "@/lib/seo";
const cityService = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Clara Camille - Nutricionista para brasileiros em Melbourne",
  description: "Nutricionista brasileira com atendimento online em português para quem mora em Melbourne.",
  url: `${SITE_URL}/nutricionista-brasileira-melbourne`,
  parentOrganization: { "@id": `${SITE_URL}/#business` },
  areaServed: { "@type": "City", name: "Melbourne", containedInPlace: { "@type": "State", name: "Victoria" } },
  availableLanguage: ["Portuguese"],
  telephone: "+61423038977",
  priceRange: "$$",
};

export const Route = createFileRoute("/nutricionista-brasileira-melbourne")({
  head: () =>
    pageHead({
      title: "Nutricionista brasileira em Melbourne | Clara Camille",
      description:
        "Nutricionista brasileira em Melbourne. Atendimento online em português com plano adaptado ao clima e à rotina local. Consulta inicial gratuita.",
      path: "/nutricionista-brasileira-melbourne",
      ogDescription: "Atendimento online em português para brasileiros em Melbourne. Consulta inicial gratuita.",
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Nutricionista brasileira em Melbourne", path: "/nutricionista-brasileira-melbourne" },
        ]),
        cityService,
        faqJsonLd(faqItems),
      ],
    }),
  component: Page,
});
